import React, { Component } from "react";
import ApiRequest from "../../libs/request.js";
import Nav from "./Nav";
import FeedNav from "./FeedNav";
import Hobbies from "../profile/Hobbies";
import { validFile } from "../../libs/functions";
import ProfileStats from "./ProfileStats";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import MultiSelect from "./MultiSelect";
import { MdEdit } from "react-icons/md";
import WorkHistoryForm from "./WorkHistoryForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

import ReactSelect from "react-select";
import { toast } from "react-toastify";
import { _backgroundImagePrompt } from "../../libs/constants.js";

class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "edit",
      reviews: [],
      genres: [],
      selectedGenres: [],
      cover: "",
      profile_photo: "",
      tabs: [
        {
          url: "edit",
          icon: "fa-user",
          name: "Personal Info",
        },
        {
          url: "workhistory",
          icon: "fa-video",
          name: "Work History",
        },
        {
          url: "info",
          icon: "fa-star",
          name: "Addtional Info",
        },
        {
          url: "actor",
          icon: "fa fa-theater-masks",
          name: "Actor Profile",
        },
      ],
      // Actor Profile Fields
      legal_age: false,
      birthdate: "",
      age_from: "",
      age_to: "",
      union_status: "",
      authentic_roles: "",
      ethnic_appearance: "",
      athletic_endeavors: "",
      performance_skills: "",
      accents: "",
      esl: "",
      fluent_languages: "",
      disabilities: "",
      assistive_devices: "",
    };

    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.uploaderMode = "cover";
  }

  render() {
    if (!this.state.id) {
      return <div />;
    }

    var occupation =
      this.state.occupation && this.state.occupation.length > 0 ? (
        this.state.occupation[0].occupation.title
      ) : (
        <p>&nbsp;</p>
      )

    var occupation_counts =
      this.state.occupation && this.state.occupation.length > 0 ? (
        this.state.occupation.length - 1
      ) : (0);

    var _errors = <div />;
    if (this.state.errors) {
      _errors = (
        <div className="alert alert-danger">{this.state.errors.join(", ")}</div>
      );
    }
    var _miles = this.state.work_radius ? this.state.work_radius : 1;
    return (
      <>
        {/* <Nav user={this.props.user} /> */}

        <div className="container-fluid" style={{padding: "0px !important" }}>
          <div className="row feed" style={{padding: "0px !important" }}>

            {/* LEFT SIDEBAR */}
            {/* <div className="col-lg-2 d-none d-lg-block p-0 feed-container">
              <div className="sticky-top vh-100 bg-white border-end feed-left">
                <FeedNav user={this.props.user} />
              </div>
            </div> */}

            {/* MAIN CONTENT */}
            <div className="col-12 col-lg-12 nopad" style={{padding: "0px !important" }}>

              {/* COVER */}
              <div className="position-relative" style={{padding: "0px !important" }}>
                <div
                  className="w-100"
                  style={{
                    height: "220px",
                    background: `url(${this.state.cover}) center/cover`,
                    borderRadius: "0 0 20px 20px",
                    position: "relative",
                    cursor: "pointer",
                  }}
                  onClick={() => this.handleFileClick("cover")}
                >
                  {/* Cover Image Edit */}
                  {this.state.cover && (
                    <MdEdit
                      onClick={() => this.handleFileClick("cover")}
                      style={{
                        fontSize: "28px",
                        color: "white",
                        cursor: "pointer",
                        position: "absolute",
                        right: "15px",
                        bottom: "15px",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "8px",
                        borderRadius: "4px",
                      }}
                    />
                  )}
                  <input
                    type="file"
                    className="hidden-upload-field"
                    id="cover-image-field"
                    onChange={this.handleFileUpload}
                  />
                </div>

                {/* PROFILE IMAGE */}
                <div
                  className="position-absolute"
                  style={{
                    bottom: "-50px",
                    left: "20px",
                  }}
                >
                  <div
                    style={{
                      width: "110px",
                      height: "110px",
                      borderRadius: "50%",
                      background: `url(${this.state.profile_photo}) center/cover`,
                      border: "4px solid white",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => this.handleFileClick("profile_photo")}
                  >
                    {/* Profile Photo Edit */}
                    {this.state.profile_photo && (
                      <MdEdit
                        onClick={() => this.handleFileClick("profile_photo")}
                        style={{
                          fontSize: "28px",
                          color: "white",
                          cursor: "pointer",
                          position: "absolute",
                          bottom: "8px",
                          right: "8px",
                          backgroundColor: "rgba(0, 0, 0, 0.6)",
                          padding: "6px",
                          borderRadius: "4px",
                        }}
                      />
                    )}
                  </div>
                  <input
                    type="file"
                    className="hidden-upload-field"
                    id="profile_photo-image-field"
                    onChange={this.handleFileUpload}
                  />
                </div>
              </div>

              {/* USER INFO */}
              <div className="bg-white p-2 p-sm-4 mt-5 rounded shadow-sm">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                  <div>
                    <h4 className="mb-1">
                      {this.state.first_name} {this.state.last_name}
                    </h4>
                    <p className="text-muted mb-0">
                      {occupation}
                    </p>
                  </div>
                  <div className="mt-3 mt-md-0">
                    <ProfileStats user={this.state} showRequestButton={false} />
                  </div>
                </div>
              </div>

              {/* TABS */}
              <div className="bg-white mt-3 p-2 rounded shadow-sm">
                <div className="d-flex flex-wrap gap-2">
                  {this.state.tabs.map((tab) => {
                    const isActive = this.state.tab === tab.url;
                    return (
                      <button
                        key={tab.url}
                        onClick={() => this.setState({ tab: tab.url })}
                        style={{
                          backgroundColor: isActive ? "#ff9500" : "white",
        color: isActive ? "white" : "#ff9500",
        border: "0px solid #ff9500",
        borderRadius: "8px",
        padding: "5px 20px",
        cursor: "pointer",
        fontWeight: 500,
        transition: "all 0.3s ease",
        marginRight: "10px",
                        }}
                        onMouseOver={(e) => {
                          if (!isActive) {
                            e.currentTarget.style.backgroundColor = "#ff9500";
                            e.currentTarget.style.color = "white";
                          }
                        }}
                        onMouseOut={(e) => {
                          if (!isActive) {
                            e.currentTarget.style.backgroundColor = "white";
                            e.currentTarget.style.color = "#ff9500";
                          }
                        }}
                      >
                        {tab.name}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* CONTENT */}
              <div className="bg-white mt-3 p-2 p-md-4 rounded shadow-sm">
                {_errors}
                {this.state.tab === "edit" && (
                  <form id="profileForm" className="gorilla-form">
                    <h2>Personal Information</h2>

                    <div className="row m-0 p-0">
                      <div className="col-md-6 col-12 m-0 p-0 pr-md-4 pl-md-6">
                        <label>First Name</label>
                        <input
                          name="first_name"
                          value={this.state.first_name || ""}
                          onChange={this.handleFormChange}
                          className="form-control"
                            style={{background: "white", outline: "3px solid #F5F5F5"}}
                          placeholder="First Name"
                        />
                      </div>
                      <div className="col-md-6 col-12 m-0 pl-md-6 p-0 pb-md-4">
                        <label>Last Name</label>
                        <input
                          name="last_name"
                          value={this.state.last_name || ""}
                          onChange={this.handleFormChange}
                            style={{background: "white", outline: "3px solid #F5F5F5"}}
                          className="form-control"
                          placeholder="Last Name"
                        />
                      </div>
                      <div className="col-md-6 col-12 m-0 p-0 pr-md-4 pl-md-6">
                        <label>Phone</label>
                        <PhoneInput
                          value={this.state.phone || ""}
                          onChange={(phone) => this.setState({ phone })}
                            style={{background: "white", outline: "3px solid #F5F5F5"}}
                        />
                      </div>
                      <div className="col-md-6 col-12 m-0 pl-md-6 p-0 pb-md-4">
                        <label>Zip Code</label>
                        <input
                          name="zip"
                          value={this.state.zip == "null" ? "" : this.state.zip || ""}
                          onChange={this.handleFormChange}
                          className="form-control"
                            style={{background: "white", outline: "3px solid #F5F5F5"}}
                          placeholder="Zip"
                        />
                      </div>
                      <div className="col-md-6 col-12 m-0 p-0 pr-md-4 pl-md-6">
                        <label>IMDb Link</label>
                        <input
                          name="imdb"
                          value={this.state.imdb || ""}
                          onChange={this.handleFormChange}
                          className="form-control"
                          placeholder="IMDb Link"
                            style={{background: "white", outline: "3px solid #F5F5F5"}}
                        />
                      </div>
                      <div className=" col-12 col-md-6 m-0 pl-md-6 p-0 pb-md-4">
                        <label>Occupations</label>
                        <ReactSelect
                          placeholder="Select Occupations"
                          options={this.state.genres}
                          isMulti
                          value={this.state.selectedGenres}
                            style={{background: "white", outline: "3px solid #F5F5F5"}}
                          onChange={(selectedOptions) => this.setState({ selectedGenres: selectedOptions })}
                        />
                      </div>
                      <div className="col-12 m-0 p-0 pb-md-4">
                        <label>Email</label>
                        <input
                          name="email"
                          value={this.state.email || ""}
                          onChange={this.handleFormChange}
                          className="form-control"
                            style={{background: "white", outline: "3px solid #F5F5F5"}}
                          placeholder="Email"
                          readOnly={true}
                        />
                      </div>
                      <div className="col-12 m-0 p-0 pb-md-4">
                        <label>Work Radius</label>
                        <br />
                        <input
                          type="range"
                          style={{ width: "100%",background: "white", outline: "3px solid #F5F5F5" }}
                          id="work_radius"
                          defaultValue={this.state.work_radius || "1"}
                          onChange={this.handleSlider.bind(this)}
                            // style={{}}
                          min="1"
                          max="12500"
                          step="1"
                        />
                        <br />
                        <span className="sliderVal">{_miles}</span> miles
                      </div>
                      <div className="col-12 m-0 p-0 pb-md-4">
                        <label>About Me</label>
                        <textarea
                          name="tell_us"
                          value={this.state.tell_us || ""}
                          onChange={this.handleFormChange}
                          style={{ height: "160px" ,background: "white", outline: "3px solid #F5F5F5"}}
                          className="form-control textarea"
                          placeholder="Tell us about yourself"
                        ></textarea>
                      </div>
                      <Hobbies
                        user_hobbies={this.state.hobbies || []}
                        onHobbiesChange={(hobbies) => {
                          this.setState({ hobbies: hobbies });
                        }}
                      />

                      <div className="row m-0 p-0" style={{width: "100%"}}>
                        <div className="col-12 m-0 p-0" style={{width: "100%"}}>
                          <button
                            className=" cus-save-btn"
                            type="button"
                          
                            onClick={this.handleProfileSave.bind(this)}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                      <p>&nbsp;</p>
                    </div>
                  </form>
                )}
                {this.state.tab === "workhistory" && (
                  <WorkHistoryForm istab={true} user={this.state} editable={true} url={"/profile"} />
                )}
                {this.state.tab === "info" && (
                  <div style={{ padding: "20px" }}>
                    <h2>Additional Information</h2>
                  </div>
                )}
                {this.state.tab === "actor" && (
                  <div className="actor-profile-view" style={{ padding: "0px", width: "100%" }}>
                    <h2>Actor Profile</h2>
                    
                    {/* Legal Age Required Badge */}
                    <div style={{ marginBottom: "20px" }}>
                      <label style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", display: "block", color: "#000" }}>
                        <input
                          type="checkbox"
                          name="legal_age"
                          checked={this.state.legal_age || false}
                          onChange={(e) => this.setState({ legal_age: e.target.checked })}
                          style={{ marginRight: "10px" }}
                        />
                        18 OR OLDER OR LEGALLY EMANCIPATED
                      </label>
                    </div>

                    {/* Birthdate */}
                    <div style={{ marginBottom: "20px", borderTop: "1px solid #e0e0e0", paddingTop: "15px" }}>
                      <div style={{ fontSize: "16px", color: "#333", fontWeight: "500" }}>Birthdate</div>
                      <DatePicker
                        selected={this.state.birthdate ? new Date(this.state.birthdate) : null}
                        onChange={(date) => {
                          const formattedDate = date ? date.toISOString().split('T')[0] : "";
                          this.setState({ birthdate: formattedDate });
                        }}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="Select a date"
                        className="form-control"
                        style={{
                          width: "100%",
                          padding: "12px",
                          marginTop: "8px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          cursor: "pointer",
                        }}
                      />
                    </div>

                    {/* Age Range (to play) */}
                    <div style={{ marginBottom: "20px", borderTop: "1px solid #e0e0e0", paddingTop: "15px" }}>
                      <div style={{ fontSize: "16px", color: "#333", fontWeight: "500", marginBottom: "10px" }}>
                        Age Range (to play)
                      </div>
                      <div style={{ display: "flex", gap: "20px" }}>
                        <div style={{ flex: 1 }}>
                          <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: "#999" }}>
                            FROM
                          </label>
                          <Select
                            options={Array.from({ length: 60 }, (_, i) => i + 18).map((age) => ({
                              value: age,
                              label: `${age} years`,
                            }))}
                            value={this.state.age_from ? { value: this.state.age_from, label: `${this.state.age_from} years` } : null}
                            onChange={(option) => this.setState({ age_from: option ? option.value : null })}
                            isClearable
                            isSearchable
                            placeholder="Select Age"
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: "#999" }}>
                            TO
                          </label>
                          <Select
                            options={Array.from({ length: 60 }, (_, i) => i + 18).map((age) => ({
                              value: age,
                              label: `${age} years`,
                            }))}
                            value={this.state.age_to ? { value: this.state.age_to, label: `${this.state.age_to} years` } : null}
                            onChange={(option) => this.setState({ age_to: option ? option.value : null })}
                            isClearable
                            isSearchable
                            placeholder="Select Age"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Expandable Sections - 2 columns layout */}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", marginTop: "20px" }}>
                      {[
                        { label: "Union Status", field: "union_status", options: ["SAG-AFTRA", "Non-Union", "Both", "Eligible"] },
                        { label: "Authentic Roles*", field: "authentic_roles", options: ["Hero", "Villain", "Comic Relief", "Love Interest", "Supporting Role"] },
                        { label: "Ethnic Appearance", field: "ethnic_appearance", options: ["Caucasian", "African American", "Asian", "Hispanic", "Middle Eastern", "Mixed"] },
                        { label: "Athletic Endeavors", field: "athletic_endeavors", options: ["Boxing", "Running", "Swimming", "Martial Arts", "Gymnastics", "Parkour"] },
                        { label: "Performance Skills", field: "performance_skills", options: ["Singing", "Dancing", "Instruments", "Comedy", "Stunts", "Accents"] },
                        { label: "Accents", field: "accents", options: ["British", "Irish", "French", "Spanish", "German", "Russian", "Australian"] },
                        { label: "ESL", field: "esl", options: ["Yes", "No"] },
                        { label: "Fluent Languages", field: "fluent_languages", options: ["Spanish", "French", "German", "Italian", "Mandarin", "Japanese"] },
                        { label: "Disabilities", field: "disabilities", options: ["Deaf", "Blind", "Mobility Impaired", "Speech Impaired", "Cognitive"] },
                        { label: "Assistive Devices", field: "assistive_devices", options: ["Wheelchair", "Crutches", "Hearing Aid", "Prosthetic", "Service Dog"] },
                      ].map((item) => (
                        <div
                          key={item.field}
                          style={{
                            flex: "1 1 calc(50% - 10px)",
                            minWidth: "250px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div style={{ fontSize: "16px", color: "#333", fontWeight: "500", marginBottom: "8px" }}>
                            {item.label}
                          </div>
                          <Select
                            options={item.options.map((option) => ({
                              value: option,
                              label: option,
                            }))}
                            value={this.state[item.field] ? { value: this.state[item.field], label: this.state[item.field] } : null}
                            onChange={(option) => this.setState({ [item.field]: option ? option.value : null })}
                            isClearable
                            isSearchable
                            placeholder={`Select ${item.label}`}
                          />
                        </div>
                      ))}
                    </div>

                    {/* Save Button */}
                    <div style={{ marginTop: "30px" }}>
                      <button
                        className="g-button"
                        type="button"
                        onClick={() => this.handleProfileSave()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  handleReviews() { }
  handleFormChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handleSlider(e) {
    let slider = document.querySelector(".sliderVal");
    slider.innerText = e.target.value;
  }
  handleOccupations() {
    let apiRequest = new ApiRequest("post", "/user/update-profile");
    let params = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      phone: this.state.phone,
      email: this.state.email,
      occupation: this.state.selectedGenres.map((genre) => genre.value),
      zip: this.state.zip,
      imdb: this.state.imdb,
      work_radius: document.getElementById("work_radius").value,
      tell_us: this.state.tell_us,
    };
    apiRequest.send(params, (response) => {
      let result = response.data;
      if (result.errors) {
        this.setState({ errors: result.message });
      } else {
        location.href = "/profile/occupations";
      }
    });
  }

  handleFileUpload() {
    var formData = new FormData();
    var imagefile = document.querySelector(
      "#" + this.uploaderMode + "-image-field"
    );
    
    if (!imagefile || !imagefile.files[0]) {
      console.error("No file selected");
      return;
    }

    formData.append(this.uploaderMode, imagefile.files[0]);
    if (!validFile(imagefile, "photo")) {
      return;
    }

    let apiRequest = new ApiRequest("post", "/user/update-profile");
    apiRequest.send_file(formData, (response) => {
      // Add proper null/undefined checks
      if (!response || !response.data) {
        console.error("Invalid response from server");
        return;
      }

      let result = response.data;
      console.log(result);
      
      if (result?.errors) {
        this.setState({ errors: result.message });
      } else if (result?.user) {
        // Update state with new image URLs
        if (this.uploaderMode === "cover") {
          this.setState({ cover: result.user.cover || "" });
        } else {
          this.setState({ profile_photo: result.user.profile_photo || "" });
        }
      }
      
      this.fetchProfile();
    });
    this.fetchProfile();
  }

  phonenumber(val) {
    var phoneno = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return val.match(phoneno);
  }

  isValidUrl(str) {
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if (!regex.test(str)) {
      return false;
    } else {
      return true;
    }
  }

  handleProfileSave() {
    let apiRequest = new ApiRequest("post", "/user/update-profile");
    let params = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      phone: this.state.phone,
      zip: this.state.zip,
      imdb: this.state.imdb,
      work_radius: document.getElementById("work_radius").value,
      tell_us: this.state.tell_us,
      occupation_ids: this.state.selectedGenres.map((genre) => genre.value),
      occupation: this.state.selectedGenres.map((genre) => genre.value),
    };

    // Add actor profile fields if they exist
    if (this.state.tab === "actor") {
      params.legal_age = this.state.legal_age;
      params.birthdate = this.state.birthdate;
      params.age_from = this.state.age_from;
      params.age_to = this.state.age_to;
      params.union_status = this.state.union_status;
      params.authentic_roles = this.state.authentic_roles;
      params.ethnic_appearance = this.state.ethnic_appearance;
      params.athletic_endeavors = this.state.athletic_endeavors;
      params.performance_skills = this.state.performance_skills;
      params.accents = this.state.accents;
      params.esl = this.state.esl;
      params.fluent_languages = this.state.fluent_languages;
      params.disabilities = this.state.disabilities;
      params.assistive_devices = this.state.assistive_devices;
    }

    var _errors = [];
    if (
      !params["first_name"] ||
      (params["first_name"] && params["first_name"].length < 1)
    ) {
      _errors.push("First name is required");
    }
    if (
      params["phone"] == null ||
      (params["phone"] && params["phone"].length < 1)
    ) {
      _errors.push("Phone is required");
    }

    if (params["imdb"] && !this.isValidUrl(params["imdb"])) {
      _errors.push("IMDB Link is not a valid url");
    }
    if (params["zip"] && isNaN(this.state.zip)) {
      _errors.push("Zipcode is not valid");
    }

    if (this.state.hobbies && this.state.hobbies.length < 3 && this.state.tab === "edit") {
      toast.error("Please select at least 3 hobbies");
      return;
    }

    if (_errors.length > 0) {
      this.setState({ errors: _errors });
      window.scrollTo(0, 0);
      return;
    } else {
      this.setState({ errors: null });
    }
    apiRequest.send(params, (response) => {
      // Add proper null/undefined checks
      if (!response || !response.data) {
        console.error("Invalid response from server");
        return;
      }

      let result = response.data;
      if (result.errors || result.message) {
        this.setState({ errors: result.message || "An error occurred" });
        window.scrollTo(0, 0);
      } else {
        toast.success("Profile updated successfully!");
        this.fetchProfile();
        window.scrollTo(0, 0);
      }
    });
  }

  handleFileClick(uploader) {
    const fileInput = document.getElementById(uploader + "-image-field");
    if (fileInput) {
      fileInput.click();
      this.uploaderMode = uploader;
    } else {
      console.error(`File input element for ${uploader} not found`);
    }
  }

  fetchProfile() {
    let api = new ApiRequest("get", "/user/view-profile");
    api.send({}, (response) => {
      // Add proper null/undefined checks
      if (!response || !response.data) {
        console.error("Invalid response from server");
        return;
      }

      let result = response.data;
      
      if (!result.user) {
        console.error("User data not found in response");
        return;
      }

      var user = result.user;
      this.setState({
        ...user,
        cover: user.cover || "",
        profile_photo: user.profile_photo || ""
      });

      if (user.occupation && user.occupation.length > 0) {
        this.setState({ 
          selectedGenres: user.occupation.map((genre) => ({ 
            value: genre.occupation.id, 
            label: genre.occupation.title 
          })) 
        });
      }
    });
  }

  componentDidMount() {
    this.fetchProfile();
    let interests = new ApiRequest("get", "/user/interests");
    interests.send({}, (response) => {
      if (response && response.data && response.data.interests) {
        this.setState({ hobbies: response.data.interests });
      }
    });


    let genreApi = new ApiRequest("get", "/user/crew-types");
    genreApi.send({}, (response) => {
      if (response && response.data && response.data.types) {
        const options = response.data.types.map((primaryType) => {
          const primaryOption = {
            label: primaryType.name,
            options: primaryType.secondary.map((secondaryType) => ({
              value: secondaryType.id,
              label: secondaryType.name,
            })),
          };
          return primaryOption;
        });

        this.setState({ genres: options });
      }
    });

  }


}

export default EditProfile;
